import { render, staticRenderFns } from "./TheSystemBar.vue?vue&type=template&id=0ff4f620&"
import script from "./TheSystemBar.vue?vue&type=script&lang=js&"
export * from "./TheSystemBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports